import React from 'react'
import { string, object } from 'prop-types'
import Container from 'Primitive/Container'

import ResponsiveMedia from 'Primitive/ResponsiveMedia'
import VideoPlayer from 'Primitive/Video'
import RoundedOverlay from 'Common/RoundedOverlay'

import styles from './Video.module.scss'
import Type from 'Primitive/Type'

const Video = ({ title, description, video, additionalParams }) => {
  const { videoId, videoType, alt, caption } = video
  return (
    <Container size="full" className={styles.Video}>
      <RoundedOverlay className={styles.VideoOverlay} />
      <Container
        size="large"
        spacious
        center
        gutter
        className={styles.VideoInner}
      >
        {title && (
          <Type className={styles.Title} size="displayLarge" as="h3">
            {title}
          </Type>
        )}
        {description && (
          <Type className={styles.Description} size="base" as="p">
            {description}
          </Type>
        )}
        <ResponsiveMedia className={styles.VideoWrapper} ratio={9 / 16}>
          <VideoPlayer
            videoId={videoId}
            videoType={videoType}
            alt={alt}
            caption={caption}
            additionalParams={{ byline: 0, title: 0, ...additionalParams }}
          />
        </ResponsiveMedia>
      </Container>
    </Container>
  )
}

Video.propTypes = {
  title: string,
  description: string,
  video: object,
  additionalParams: object
}

export default Video
